import { initSurveyBanner } from 'frontend/shared/javascripts/modules/survey_banner/survey_banner'

initSurveyBanner()
